import { t } from 'i18next';
import React, { FC } from 'react';

import { Trigger, TriggerButtonProps } from '../DropdownMenu/TriggerButton';
import Menu from '../Menu';
import MenuItem from '../MenuItem';

interface CollectionCreateDropdownProps {
  triggerComponent: Trigger<TriggerButtonProps>;
  actions: Array<{ onClick: () => void; label: string }>;
}

const ActionDropdownContent: FC<{ action: { onClick: () => void; label: string } }> = ({ action }) => {
  return (
    <MenuItem href="#" onClick={action.onClick}>
      {action.label}
    </MenuItem>
  );
};

const CollectionCreateDropdown = ({
  actions,
  triggerComponent: TriggerComponent,
}: CollectionCreateDropdownProps): JSX.Element | null => (
  <Menu title={t('collection.add')} trigger={TriggerComponent}>
    {() => (
      <React.Fragment>
        {actions.map((action) => (
          <ActionDropdownContent action={action} key={action.label} />
        ))}
      </React.Fragment>
    )}
  </Menu>
);

export default CollectionCreateDropdown;
